export default __webpack_public_path__ + "static/media/docs-icon.d0339783.svg";